import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ISanitationEvent {
    copy: string;
    tag?: string;
    content?: 'html' | 'basicHtml';
    contentClass?: string | string[];
}

@Injectable({
    providedIn: 'root'
})
export class ICmsDirectiveSanitationService {
    readonly sanitation$ = new Subject<ISanitationEvent>();
}
